import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UploadProcessingDataObjectFragment = { __typename: 'DataObject', id: string, mediaType?: string | null, metadataProcessingJob?: { __typename: 'Job', id: string } | null, thumbnailProcessingJob?: { __typename: 'Job', id: string } | null };

export type UploadProcessingDataObjectQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  legacyId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type UploadProcessingDataObjectQuery = { __typename: 'Query', dataObject: { __typename: 'DataObject', id: string, mediaType?: string | null, metadataProcessingJob?: { __typename: 'Job', id: string } | null, thumbnailProcessingJob?: { __typename: 'Job', id: string } | null } };

export type UploadProcessingProcessUploadMutationVariables = Types.Exact<{
  dataObjectId: Types.Scalars['String']['input'];
  generateTiles?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type UploadProcessingProcessUploadMutation = { __typename: 'Mutation', processUpload: { __typename: 'Job', id: string } };

export const UploadProcessingDataObjectFragmentDoc = gql`
    fragment UploadProcessingDataObject on DataObject {
  id
  mediaType
  metadataProcessingJob {
    id
  }
  thumbnailProcessingJob {
    id
  }
}
    `;
export const UploadProcessingDataObjectDocument = gql`
    query uploadProcessingDataObject($id: ID, $legacyId: Int) {
  dataObject(id: $id, legacyId: $legacyId) {
    ...UploadProcessingDataObject
  }
}
    ${UploadProcessingDataObjectFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadProcessingDataObjectGQL extends Apollo.Query<UploadProcessingDataObjectQuery, UploadProcessingDataObjectQueryVariables> {
    override document = UploadProcessingDataObjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadProcessingProcessUploadDocument = gql`
    mutation uploadProcessingProcessUpload($dataObjectId: String!, $generateTiles: Boolean) {
  processUpload(
    dataObjectId: $dataObjectId
    options: {generateTiles: $generateTiles}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadProcessingProcessUploadGQL extends Apollo.Mutation<UploadProcessingProcessUploadMutation, UploadProcessingProcessUploadMutationVariables> {
    override document = UploadProcessingProcessUploadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }